import { cn } from '@/lib/cn';
import { useUnsavedChanges } from '@/lib/unsaved-changes';
import { Button } from './button';

/**
 * The footer of a settings form (settings-save): nothing is applied until Save. Save is disabled
 * until something changed, Cancel puts the saved values back, and "Unsaved changes" shows while the
 * draft differs. It also warns before leaving with unsaved changes (useUnsavedChanges).
 * Without `onSave`, Save is the form's submit button.
 */
export function SettingsSaveBar({
  dirty,
  saving,
  onSave,
  onCancel,
  saveLabel = 'Save',
  className,
}: {
  dirty: boolean;
  saving?: boolean;
  onSave?: () => void;
  onCancel: () => void;
  saveLabel?: string;
  className?: string;
}) {
  useUnsavedChanges(dirty);
  return (
    <div className={cn('flex flex-wrap items-center justify-end gap-2', className)}>
      {dirty ? (
        <span role="status" className="mr-auto text-sm text-warning">
          Unsaved changes
        </span>
      ) : null}
      <Button onClick={onCancel} disabled={!dirty || saving}>
        Cancel
      </Button>
      <Button type={onSave ? 'button' : 'submit'} variant="primary" onClick={onSave} disabled={!dirty} loading={saving}>
        {saveLabel}
      </Button>
    </div>
  );
}
